import classNames from 'classnames';
import React from 'react';

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  None = 'none',
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant | 'primary' | 'secondary' | 'danger' | 'none';
  className?: string;
  loading?: boolean;
}

const baseStyles =
  'inline-flex items-center justify-center px-4 py-1.5 rounded text-sm howio-font-md focus:outline-none transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

const variantStyles: Record<string, string> = {
  none: 'bg-transparent hover:underline ',
  primary: 'bg-howio-purple  border-howio-purple border text-white hover:bg-indigo-600',
  secondary: 'bg-white border-gray-200 border text-gray-700 hover:bg-gray-100',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className = '',
  loading = false,
  disabled,
  ...props
}) => {
  return (
    <button
      className={classNames(baseStyles, variantStyles[variant], className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;
